(function (window) {
    "use strict";

    DSV.template.paginationButton = {
        getTemplate: (page, currentPage, index, buttonAmount, totalPages) => {
            const prevButton = index === 0;
            const nextButton = index === buttonAmount - 1;
            
            if (prevButton) {
                return `
                <li class="pagination__item pagination__item--prev" ${currentPage === 0 ? "disabled" : ""} data-pagination-offset="${page.Offset + 1}">
                    <a class="pagination__link ${(currentPage === page.Page) ? 'selected' : ''}" ${currentPage === 0 ? "tabindex=\"-1\"" : ""} href="#">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8">
                            <path fill-rule="evenodd" d="M6.384 7.364l5.47-6.003a.508.508 0 0 0 0-.714.501.501 0 0 0-.71 0L6.004 6.29.859.647a.501.501 0 0 0-.71 0 .508.508 0 0 0 0 .714l5.47 6.003c.105.105.245.15.385.143a.498.498 0 0 0 .38-.143"/>
                        </svg>
                    </a>
                </li>`
            }

            if (nextButton) {
                return `
                <li class="pagination__item pagination__item--next" ${currentPage === totalPages - 1 ? "disabled" : ""} data-pagination-offset="${page.Offset + 1}">
                    <a class="pagination__link ${(currentPage === page.Page) ? 'selected' : ''}" ${currentPage === totalPages - 1 ? "tabindex=\"-1\"" : ""}  href="#">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8">
                            <path fill-rule="evenodd" d="M6.384 7.364l5.47-6.003a.508.508 0 0 0 0-.714.501.501 0 0 0-.71 0L6.004 6.29.859.647a.501.501 0 0 0-.71 0 .508.508 0 0 0 0 .714l5.47 6.003c.105.105.245.15.385.143a.498.498 0 0 0 .38-.143"/>
                        </svg>
                    </a>
                </li>`
            }

            return `
            <li class="pagination__item ${(currentPage === page.Page) ? 'pagination__item--active' : ''}" data-pagination-offset="${page.Offset + 1}">
                <a class="pagination__link" href="#">
                    ${page.Label}
                </a>
            </li>`
        }
    };
})(window);